module.exports = __webpack_public_path__ + "img/pdf-logo.e05883b9.png";